import React, { useEffect, useState } from "react";
import config from "../coreFIles/config";
import Cookies from "js-cookie";
import { CgMenuLeft } from "react-icons/cg";
import { GetAdminProfileDetails } from "../Action/action";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const loginData = !Cookies.get("OnchainMatrix")
    ? {}
    : JSON.parse(Cookies.get("OnchainMatrix"));

  const [AdminProfile, setAdminProfile] = useState({
    email: "",
    password: "",
    fname: "",
    lname: "",
    profileImg: "",
  });

  useEffect(() => {
    const hasClass = document.body.classList.contains("sidebar-collapse");
    setIsCollapsed(hasClass);
  }, []);


  const logout = () => {
    Cookies.remove("OnchainMatrix");
    window.location.href = config.baseUrl;
  };

  const profile = () => {
    navigate(`${config.baseUrl}profile`);
  };

  useEffect(() => {
    getAdminProfile();
  }, []);

  const getAdminProfile = async () => {
    try {
      setIsLoading(true);
      let res = await GetAdminProfileDetails();
      if (res?.status) {
        setAdminProfile({
          email: res.data.email,
          password: res.data.password,
          fname: res.data.fname,
          lname: res.data.lname,
          profileImg: res.data.profileImg,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.response.status === 401) {
        logout();
      }
    }
  };

  useEffect(() => {
    const savedState = localStorage.getItem("sidebarCollapsed") === "true";

    setIsCollapsed(savedState);

    if (savedState) {
      document.body.classList.add("sidebar-collapse");
    }
  }, []);



  return (
    <>
      <header className="main-header">
        <div className="d-flex align-items-center logo-box justify-content-start">
          <a href="#" className="logo py-2">
            <div className="logo-mini w-50">
              <span className="light-logo">
                <img
                  src={
                    isCollapsed
                      ? "images/logo/logo_new.png"
                      : "images/logo/logo_new.png"
                  }
                  alt="logo"
                  width={isCollapsed ? "40px" : "100px"}
                />
              </span>
            </div>


            <div className="logo-lg">
              <span className="light-logo">
                <img src="images/logo/logo_new.png" alt="logo"  style={{height:"85px",width:"85px"}}/>
              </span>
              <span className="dark-logo">
                <img src="images/logo/logo_new.png" alt="logo" style={{height:"85px",width:"85px"}}/>
              </span>
            </div>
          </a>
        </div>

        {/* Navbar */}
        <nav className="navbar navbar-static-top">
          <div className="app-menu">
            <ul className="header-megamenu nav">
              <li className="btn-group nav-item">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsCollapsed((prev) => {
                      const newState = !prev;

                      if (newState) {
                        document.body.classList.add("sidebar-collapse");
                      } else {
                        document.body.classList.remove("sidebar-collapse");
                      }

                      return newState;
                    });

                  }}
                  className="nav-link push-btn btn-primary-light"
                >
                  <CgMenuLeft />
                </a>

              </li>
            </ul>
          </div>

          <div className="navbar-custom-menu r-side">
            <ul className="nav navbar-nav d-flex align-items-center gap-2">



              {/* 👤 USER DROPDOWN */}
              <li className="dropdown user user-menu">
                <a
                  href="#"
                  className="dropdown-toggle w-auto l-h-12 bg-transparent py-0 no-shadow"
                  data-bs-toggle="dropdown"
                >
                  <div className="d-flex align-items-center">
                    <div className="text-end me-10">
                      <p className="pt-5 fs-14 mb-0 fw-700 text-primary">
                        {loginData?.username || "Admin"}
                      </p>
                      <small className="fs-6 mb-0 text-uppercase text-mute">
                        Welcome, {AdminProfile.fname} {AdminProfile.lname}
                      </small>
                    </div>

                    <img
                      src={
                        AdminProfile.profileImg
                          ? AdminProfile.profileImg
                          : "./images/avatar/avatar-1.png"
                      }
                      alt="avatar"
                      className="img-fluid rounded-circle mb-0 h-40 w-40 object-fit-cover"
                    />
                  </div>
                </a>

                <ul className="dropdown-menu animated flipInX">
                  <li className="user-body">
                    {/* <a className="dropdown-item" href="#" onClick={profile}>
                      <i className="fa fa-user text-muted me-2" /> Profile
                    </a> */}
                    <a className="dropdown-item" href="#" onClick={logout}>
                      <i className="ti-lock text-muted me-2" /> Logout
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
